import React from 'react';
import FormSection from './FormSection';
import { TextArea } from '../common';
import Select from '../common/Select';
import MultiSelect from '../common/MultiSelect';
import { 
  AUDIT_METHOD_OPTIONS,
  INTERNAL_DEPARTMENT_OPTIONS,
  INTERNAL_SCOPE_OPTIONS,
  TYPE_VENDOR_OPTIONS,
  EXTERNAL_SCOPE_OPTIONS,
  APPLICABLE_STANDARDS_OPTIONS
} from './constants';

const AuditScopeMethod = ({ formData, onChange, errors = {} }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Clear error for the field if it has a value
    const updatedData = { [name]: value };
    const updatedErrors = { ...errors };
    
    if (value) {
      delete updatedErrors[name];
      onChange(updatedData, updatedErrors);
    } else {
      onChange(updatedData);
    }
  };

  // Separate handler for multi-select to handle array values
  const handleMultiSelectChange = (e) => {
    const { name, value } = e.target;
    
    // Clear error for the field if it has values
    const updatedData = { [name]: value };
    const updatedErrors = { ...errors };
    
    if (value && value.length > 0) {
      delete updatedErrors[name];
      onChange(updatedData, updatedErrors);
    } else {
      onChange(updatedData);
    }
  };

  return (
    <FormSection title="Audit Scope & Method">
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <MultiSelect
            label="Audit Method"
            name="auditMethod"
            value={formData.auditMethod || []}
            onChange={handleMultiSelectChange}
            options={AUDIT_METHOD_OPTIONS}
            error={errors.auditMethod}
            required
          />

          <MultiSelect
            label="Internal Department"
            name="internalDepartment"
            value={formData.internalDepartment || []}
            onChange={handleMultiSelectChange}
            options={INTERNAL_DEPARTMENT_OPTIONS}
            error={errors.internalDepartment}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <MultiSelect
            label="Internal Scope"
            name="internalScope"
            value={formData.internalScope || []}
            onChange={handleMultiSelectChange}
            options={INTERNAL_SCOPE_OPTIONS}
            error={errors.internalScope}
          />

          <Select
            label="Type Vendor"
            name="typeVendor"
            value={formData.typeVendor}
            onChange={handleInputChange}
            options={TYPE_VENDOR_OPTIONS}
            error={errors.typeVendor}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <MultiSelect
            label="External Scope"
            name="externalScope"
            value={formData.externalScope || []}
            onChange={handleMultiSelectChange}
            options={EXTERNAL_SCOPE_OPTIONS}
            error={errors.externalScope}
          />

          <Select
            label="Applicable Standards"
            name="applicableStandards"
            value={formData.applicableStandards}
            onChange={handleInputChange}
            options={APPLICABLE_STANDARDS_OPTIONS}
            error={errors.applicableStandards}
            required
          />
        </div>

        <TextArea
          label="Objective"
          name="objective"
          value={formData.objective}
          onChange={handleInputChange}
          error={errors.objective}
          rows={4}
          required
        />
      </div>
    </FormSection>
  );
};

export default AuditScopeMethod;
